// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1eab3640","455":"6aeda4e3"}[chunkId] + ".chunk.js";
};